import React from "react";

import { observer } from "mobx-react-lite";

import { ConfirmationModal } from "src/base-components/ConfirmationModal";
import { useGraphStore } from "src/store/StoreProvider";

export const UngroupModal: React.FC = observer(() => {
  const {
    groups,
    deleteGroup,
    setIsUngroupModalVisible,
    setGroupToChangeId,
    groupToChangeId,
    isUngroupModalVisible,
  } = useGraphStore();
  const onClose = () => {
    setIsUngroupModalVisible(false);
    setGroupToChangeId(null);
  };
  const groupName = groupToChangeId && groups.get(groupToChangeId)?.data.label;
  const onConfirmDelete = async () => {
    if (groupToChangeId) {
      await deleteGroup(groupToChangeId);
      onClose();
    }
  };
  return (
    <ConfirmationModal
      confirmationButtonText="Yes, ungroup Node"
      open={isUngroupModalVisible}
      title="Ungroup all Nodes in this group?"
      onClose={onClose}
      onConfirm={onConfirmDelete}
    >
      <div className="font-inter-normal-12px text-gray-500">
        Are you sure you want to ungroup all the nodes of the {groupName} group?
        This action cannot be undone.
      </div>
    </ConfirmationModal>
  );
});
